import { EntityNameModal } from '@/pages/admin/shared/entity-management/EntityNameModal';

type CreateDepartmentModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onCreate: (name: string) => void;
};

export const CreateDepartmentModal = ({
	isOpen,
	onClose,
	onCreate,
}: CreateDepartmentModalProps) => {
	return (
		<EntityNameModal
			isOpen={isOpen}
			onClose={onClose}
			title="Criar Departamento"
			description="Insira o nome do novo departamento para organizar sua empresa."
			label="NOME DO DEPARTAMENTO"
			placeholder="Ex: Recursos Humanos"
			submitText="Criar departamento"
			inputId="modal-dept-name"
			onSubmitValue={onCreate}
		/>
	);
};
